export const dateType = {
  'birthday': 'birthday',
  'holiday': 'holiday'
};
